
import Loading from 'vux/src/components/loading/index.vue'

import $ from 'zepto'
export default {
name: "preLoadImg",
components: {Loading},
data() {
return {
isLoading: true,
loadedImgCnt: 0, //加载的图片数
imgCnt: 0,
}
},
/*------------------------------------------- 开始运行 -------------------------------------------*/
mounted() {
this.loadAllImg();
},
/*------------------------------------------- 自定义函数 -------------------------------------------*/
methods: {
/*  加载所有图片
* */
loadAllImg() {
let _this = this;
this.isLoading = true;
let imgs = document.querySelectorAll('.save-img-base64 img');
this.imgCnt = imgs.length;

Array.from(imgs).forEach((item) => {
let img = new Image();
img.src = item.getAttribute('src');
let name = item.getAttribute('name');
if (sessionStorage.getItem(name)){  //先查看本地有没有
this.countImgNum();
}else{
img.onload = () => {
this.countImgNum();
this.saveImgBase64(name, img);
};
img.onerror = () => {
this.countImgNum();
};
}
})
},
/*  计算图片数量，完成全部加载就关闭loading动画
* */
countImgNum(){
this.loadedImgCnt++;
if (this.loadedImgCnt >= this.imgCnt) { //所有图片加载完，就关闭loading动画
this.isLoading = false;
}
},
/*  本地保存base64代码
* @param {str}name图片的保存的名字 {obj}img图片对象
* */
saveImgBase64(name, img){
/*  获取图片的base64码
* @param {obj}img图片dom对象
* */
function getBase64Image(img) {
let canvas = document.createElement("canvas");
canvas.width = img.width;
canvas.height = img.height;
let ctx = canvas.getContext("2d");
ctx.drawImage(img, 0, 0, img.width, img.height);  //绘制相同图片
return canvas.toDataURL("image/png"); //转换成base64数据
}
let code = getBase64Image(img);
sessionStorage.setItem(name, code);
},
},
};



// WEBPACK FOOTER //
// ./src/items/saveImgBase64.vue